import React, { useState } from 'react';
import '../css/Dice.css';
import pic1 from '../images/positions/cowgirl-last-longer_1024x1024.webp';
import pic2 from '../images/positions/grinding-missionary-last-longer_1024x1024.webp';
import pic3 from '../images/positions/lazy-dog-sex-position_1024x1024.webp';
import pic4 from '../images/positions/perpendicular-sex-position_1024x1024.webp';
import pic5 from '../images/positions/Spooning-sex-position_1024x1024.webp';
import pic6 from '../images/positions/the-throne-sex-position_1024x1024.webp';
import place1 from '../images/placesToFuck/livingroom.png';
import place2 from '../images/placesToFuck/car.png';
import place3 from '../images/placesToFuck/garden.png';
import place4 from '../images/placesToFuck/bedroom.png';
import place5 from '../images/placesToFuck/kitchen.png';
import place6 from '../images/placesToFuck/bath.png';
import { useTranslation } from 'react-i18next';

const Dice = () => {
    const { t } = useTranslation();
    const [isRolling, setIsRolling] = useState(false);
    const [activeDice, setActiveDice] = useState('positions');
    const [cubeStyle, setCubeStyle] = useState({});

    const positionsList = [pic1, pic2, pic3, pic4, pic5, pic6];
    const placesList = [place1, place2, place3, place4, place5, place6];
    const currentFaces = activeDice === 'positions' ? positionsList : placesList;

    const handleRoll = () => {
        if (isRolling) return;

        setIsRolling(true);
        if (navigator.vibrate) {
            navigator.vibrate([100, 30, 100, 30, 100]);
        }
        const randomFace = Math.floor(Math.random() * 6) + 1;

        const rotations = {
            1: { transform: 'rotateX(0deg) rotateY(0deg)' },
            2: { transform: 'rotateX(-90deg)' },
            3: { transform: 'rotateY(90deg)' },
            4: { transform: 'rotateY(-90deg)' },
            5: { transform: 'rotateX(90deg)' },
            6: { transform: 'rotateY(180deg)' }
        };

        // Reset animation to allow re-triggering
        setCubeStyle({
            animation: 'none'
        });
        
        // Force reflow to apply the reset style before adding the animation
        void document.body.offsetWidth;

        setCubeStyle({
            animation: `roll 8s ease-out`,
            ...rotations[randomFace]
        });

        setTimeout(() => {
            setIsRolling(false);
            setCubeStyle(rotations[randomFace]);
        }, 8000);
    };

    return (
        <div className="dicePage d-flex gap-5 justify-content-center align-items-center flex-column fade-in">
            <h1 className="text-center" style={{ marginBottom: '0.5rem' }}>{t('diceH')}</h1>
            <div className="diceButtons">
                <button
                    className={`button ${activeDice === 'positions' ? 'active' : ''}`}
                    onClick={() => setActiveDice('positions')}
                    disabled={isRolling}
                    aria-label={t('positionDice')}
                >
                    {t('positionDice')}
                </button>
                <button
                    className={`button ${activeDice === 'places' ? 'active' : ''}`}
                    onClick={() => setActiveDice('places')}
                    disabled={isRolling}
                    aria-label={t('placeDice')}
                >
                    {t('placeDice')}
                </button>
            </div>
            
            <div className="scene" style={{ position: 'relative' }}>
                <div className="cube" style={cubeStyle}>
                    <div className="cube__face cube__face--front">
                        <img src={currentFaces[0]} alt="Dice Face" loading="lazy" />
                    </div>
                    <div className="cube__face cube__face--top">
                        <img src={currentFaces[1]} alt="Dice Face" loading="lazy" />
                    </div>
                    <div className="cube__face cube__face--right">
                        <img src={currentFaces[2]} alt="Dice Face" loading="lazy" />
                    </div>
                    <div className="cube__face cube__face--left">
                        <img src={currentFaces[3]} alt="Dice Face" loading="lazy" />
                    </div>
                    <div className="cube__face cube__face--bottom">
                        <img src={currentFaces[4]} alt="Dice Face" loading="lazy" />
                    </div>
                    <div className="cube__face cube__face--back">
                        <img src={currentFaces[5]} alt="Dice Face" loading="lazy" />
                    </div>
                </div>
            </div>

            <button 
                className="button" 
                onClick={handleRoll} 
                disabled={isRolling}
                style={{
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <span style={{ position: 'relative', zIndex: 1 }}>
                    {isRolling ? t('rolling') : t('play')}
                </span>
                {isRolling && (
                    <span
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: '-100%',
                            width: '100%',
                            height: '100%',
                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                            animation: 'shimmer 1.5s infinite'
                        }}
                    />
                )}
            </button>
        </div>
    );
};

export default Dice;
